export default __webpack_public_path__ + "static/media/procesiLegjislativ.0eb59304.png";